import React, { useEffect, useState } from 'react';


import useTranslate from '@root/core/hooks/useTranslate';
import FilterAction from '../components/filterAction';

import SellerList from '../components/SellerList';
import SellerTable from '../components/SellerTable';
import buskSeller from '../services/buskSeller';
import { stateKorea } from '../../utils/Languages';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import useDebounce from '@root/core/hooks/useDebounce';
import { formatDateTime } from '@root/utils/helpers/formatDate';

const breadcrumbList = [
  {
    tittle: '셀러 관리',
    url: ''
  },
  {
    tittle: '셀러 목록',
    url: ''
  }
];

const BuskSeller = () => {
  const [t] = useTranslate();
  //table
  const [rowData, setRowData] = useState();
  const [total, setTotal] = useState(0);
  const [selectedRow, setSelectedRow] = useState<React.Key[]>([]);
  const [loading, setLoading] = useState(false);
  // filter action
  const [filterDate, setFilterDate] = useState<[string, string]>();
  const fromDt: string = (filterDate && filterDate[0]) || '';
  const toDt: string = (filterDate && filterDate[1]) || '';
  const [filterState, setFilterState] = useState('');
  const [filter, setFilter] = useState('');
  const [filterInput, setFilterInput] = useState('');
  const debounce = useDebounce(filterInput, 1000);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState(false);

  const getSellerList = async (
    page: number,
    fromDt: string,
    toDt: string,
    filterState: string,
    filter: string,
    filterInput: string,
    sort: boolean
  ) => {
    setLoading(true);
    const buskSellerList = await buskSeller.getListSeller(
      page,
      fromDt,
      toDt,
      filterState,
      filter,
      filterInput,
      sort
    );
    const rowDataModified = buskSellerList.data?.map(
      (r: any, index: number) => {
        return {
          ...r,
          key: r.id,
          createdAt: formatDateTime(r.createdAt),
          no: r.id,
          // no: index + (page - 1) * 10 + 1,
          state: stateKorea(r.state)
        };
      }
    );
    setRowData(rowDataModified);
    setTotal(buskSellerList?.count);
    setLoading(false);
  };

  const handleStateValue = (value: string) => {
    setFilterState(value);
  };
  const handleFilterValue = (value: string) => {
    setFilter(value);
  };
  const handleInputValue = (value: string) => {
    setFilterInput(value);
  };
  const handleDateValue = (value: [string, string]) => {
    setFilterDate(value);
  };
  const onchangeSort = () => {
    setSort(!sort);
  };
  const handleChangePage = (page: number) => {
    setPage(page);
  };

  useEffect(() => {
    getSellerList(page, fromDt, toDt, filterState, filter, debounce, sort);
  }, [page]);

  useEffect(() => {
    if (page === 1) {
      getSellerList(page, fromDt, toDt, filterState, filter, debounce, sort);
    } else {
      setPage(1);
    }
  }, [fromDt, toDt, filterState, debounce, sort]);

  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="busk-container">
        <FilterAction
          handleDateValue={handleDateValue}
          handleStateValue={handleStateValue}
          handleFilterValue={handleFilterValue}
          handleInputValue={handleInputValue}
        />
        <SellerList
          rowData={rowData}
          count={total}
          selectedRow={selectedRow}
          page={page}
          fromDt={fromDt}
          toDt={toDt}
          filterState={filterState}
          filter={filter}
          filterInput={filterInput}
          sort={sort}
        />

        <SellerTable
          rowData={rowData}
          sort={sort}
          setSort={onchangeSort}
          total={total}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          loading={loading}
          handleChangePage={handleChangePage}
          page={page}
        />
      </div>
    </div>
  );
};

export default BuskSeller;
